import React from 'react';
import cx from 'classnames';

import { centsToCurrency } from '~/utils/numbers';

import styles from '~/components/cart/cart-summary/cart-summary.module.scss';

const StoreCreditLine = ({
  availableStoreCredit = 0,
  useableStoreCredit = 0,
  storeCreditRedeemed = 0,
  showCreditAvailable = true,
}) => {
  const remainingStoreCredit = availableStoreCredit - useableStoreCredit;

  return (
    <>
      {showCreditAvailable && useableStoreCredit > 0 && (
        <li className={cx(styles.cartSummaryItem, styles.storeCreditItem)}>
          <span>Store Credit</span>
          <span>-{centsToCurrency(useableStoreCredit)}</span>
        </li>
      )}

      {showCreditAvailable && remainingStoreCredit > 0 && (
        <li className={cx(styles.cartSummaryItem, styles.remainingStoreCredit)}>
          <small>
            <em>Remaining Store Credit</em>
          </small>
          <small>
            <em>{centsToCurrency(remainingStoreCredit)}</em>
          </small>
        </li>
      )}

      {!showCreditAvailable && storeCreditRedeemed > 0 && (
        <li className={cx(styles.cartSummaryItem, styles.storeCreditItem)}>
          <span>Store Credit</span>
          <span>-{centsToCurrency(storeCreditRedeemed)}</span>
        </li>
      )}
    </>
  );
};

export default StoreCreditLine;
